<template>
    <div>
        <vx-card title="Connections" id="connectionsDiv"  class="vs-con-loading__container">
            <vs-table ref="connectionsTable" :data="tableData" pagination search :maxItems="itemsPerPage">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="connection_time">Connection time</vs-th>
                    <vs-th sort-key="channel_name">Channel</vs-th>
                    <vs-th sort-key="worker_name">Worker</vs-th>
                    <vs-th sort-key="client_ip">IP</vs-th>
                    <vs-th sort-key="user_agent">User agent</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].connection_time">
                            {{ moment(data[index].connection_time).format("YYYY/MM/DD HH:mm:ss") }}
                        </vs-td>

                        <vs-td :data="data[index].channel_name">
                            {{ data[index].channel_name }}
                        </vs-td>

                        <vs-td :data="data[index].worker_name">
                            {{ data[index].worker_name }}
                        </vs-td>

                        <vs-td :data="data[index].client_ip">
                            {{ data[index].client_ip }}
                        </vs-td>

                        <vs-td :data="data[index].user_agent">
                            {{ data[index].user_agent }}
                        </vs-td>

                        <vs-td class="flex">
                            <vx-tooltip text="Kill connection" ><vs-button icon-pack="feather" icon="icon-crosshair" color="danger" class="mt-6; mr-1" @click="killConnection(data[index].id)"/></vx-tooltip>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>
    </div>
</template>

<script>
    export default {
        name: "ClientConnections",
        props: {
            clientId: {
                type: Number,
                required: true,
            }
        },
        data(){
            return {

                itemsPerPage: 10,
                isMounted: false,

                connections: []

            }
        },
        methods: {
            loadData(){

                this.$vs.loading({
                    container: "#connectionsDiv",
                    type: 'corners',
                    scale: 0.7
                });

                const thisIns = this;
                const connectionsPromise = this.$http.get('/api/reseller/v1/client/' + this.clientId + '/connection');
                connectionsPromise.then(function (response) {
                    thisIns.connections = response.data;
                }).catch(function (error) {
                    thisIns.$printError(error.response.data);
                }).finally(function () {
                    thisIns.$vs.loading.close("#connectionsDiv > .con-vs-loading");
                });

            },
            killConnection(connectionId){

                this.$vs.loading({
                    container: "#connectionsDiv",
                    type: 'corners',
                    scale: 0.7
                });

                const thisIns = this;
                const killPromise = this.$http.delete('/api/reseller/v1/client/' + this.clientId + '/connection/' + connectionId);
                killPromise.then(function () {
                    thisIns.loadData();
                }).catch(function (error) {
                    thisIns.$printError(error.response.data);
                }).finally(function () {
                    thisIns.$vs.loading.close("#connectionsDiv > .con-vs-loading");
                });

            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.connectionsTable.currentx
                }
                return 0
            },
            tableItems(){
                if(this.isMounted) {
                    return this.$refs.connectionsTable.queriedResults.length
                }
                return 0
            },
            tableData(){
                return this.connections;
            }
        },
        mounted() {
            this.isMounted = true;
            this.loadData();
        }
    }
</script>

